import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  secondaryActions: {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
    "& > .MuiButton-root": {
      padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    },
    "& :not(:first-child)": {
      marginLeft: theme.spacing(2),
    },
  },
}));
